import { Search } from "react-bootstrap-icons";
import { FileCheck } from "react-bootstrap-icons";
import { House, FiletypePdf} from "react-bootstrap-icons";

const options =[
    {
        variant: 'divider',
        label: 'Proveedor',
        roles: ['proveedor'],
        route: ''
    },
    {
        label: "Nuevo trámite de pago",
        defaultOption: false,
        icon: <FileCheck />,
        route: '/registro-documento',
        alias : [
            '/registro-documento/:tipoDOC'
        ],
        roles: ['proveedor']
    },
    {
        label :"Búsqueda",
        defaultOption: false,
        icon : <Search />,
        route : '/proveedor/tramites/search',
        /*alias : [
            '/tramite/:loteID'
        ],*/
        roles: ['proveedor']
    }/*,
    {
        label :"Ya pagados",
        defaultOption: false,
        icon : <FiletypePdf />,
        route : '/ya-pagados',
        
        roles: ['proveedor']
    }*/
];
export default options;